export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export interface ICurrency {
    id?: number;
    name?: string;
    currency?: string;
    lastModifiedDate?: string;
    rate?: number;
}

export class Currency implements ICurrency {
    constructor(public id?: number, public name?: string, public currency?: string, public code?: number, public lastModifiedDate?: string) {}
}
